import React from 'react';
import TranslatedComponent from '../../utils/TranslatedComponent';

export class EspnPlusLogo extends React.Component {
  constructor(props) {
    super(props);
  }

  render() {
    var classNames = ['logo', 'espnPlusLogo'];
    if (this.props.isPrimary) {classNames.push('primaryLogo');}
    return (
      <svg className={classNames.join(' ')} viewBox="0 0 102 21" aria-labelledby='epsn-plus-logo-title' role='img'>
        <title id='epsn-plus-logo-title'>ESPN+ Logo</title>
        <g fill="none">
            <g fill="#FFF">
                <path d="M56.019.004H26.493c-3.025-.006-5.028 1.59-5.313 3.972-.105.877-.205 1.651-.205 1.651h39.34l.132-1.046c.3-2.4-.719-4.577-4.428-4.577M60.051 7.77s-.088.794-.208 1.66c-.24 1.714-1.517 2.991-3.893 2.991h-8.375l-.95 7.622h-6.668L41.469 7.77h18.582zM2.485 0L20.33.003l-.698 5.624H1.791zM1.524 7.77h17.84l-.576 4.651H7.617l-.286 2.297H18.5l-.663 5.325H0zM62.37.004h14.549c2.3 0 4.693 1.068 4.218 4.758-.086.662-.11.865-.11.865H61.674l.695-5.623zM61.405 7.768l6.672.004-1.521 12.268-6.673.002zM74.08 7.768l6.672.004-1.523 12.268-6.672.002zM35.364 7.774L20.71 7.77c-.493 3.204 1.11 4.651 3.38 4.651l9.027-.003-.284 2.3H19.847l-.657 5.325s14.133.004 14.707 0c.472-.036 3.78-.125 4.907-2.83.366-.878.693-4.024.784-4.686.525-3.838-2.13-4.753-4.224-4.753"/>
            </g>
            <g>
                <path fill="#FFF" d="M56.574.005c3.746 0 4.77 2.224 4.467 4.68-.054.477-.132 1.07-.132 1.07H21.184s.1-.794.206-1.689C21.682 1.63 23.696 0 26.755.005h29.819zm4.07 7.943s-.086.808-.21 1.694c-.24 1.754-1.533 3.064-3.931 3.064h-8.46l-.956 7.789-6.736.005L41.88 7.948h18.765zM2.51 0l18.021.006-.707 5.75H1.809L2.51 0zm-.972 7.944h18.016l-.581 4.756H7.692l-.289 2.349h11.282l-.669 5.447H0L1.54 7.944zM62.986.004H77.68C80 .005 82.42 1.1 81.938 4.873c-.085.672-.11.883-.11.883H62.284l.702-5.75zm-2.512 20.49l1.54-12.551 6.738.004-1.536 12.545-6.742.003zm12.8 0L74.81 7.944l6.742.004-1.538 12.545-6.74.003zM35.717 7.95c2.11 0 4.796.937 4.265 4.864-.094.672-.425 3.891-.794 4.789-1.137 2.768-4.479 2.86-4.955 2.894-.576.005-14.855 0-14.855 0l.665-5.445h13.114l.286-2.355s-7.866.009-9.113.009c-2.293 0-3.912-1.484-3.414-4.762l14.8.006z"/>
                <path fill="#F9B300" d="M96.589 8.12l.615-5.191h-5.209l-.615 5.19h-4.883l-.592 5.148H90.8l-.628 5.28h5.209l.628-5.28h4.92l.594-5.147z"/>
            </g>
        </g>
      </svg>
    );
  }
}

TranslatedComponent(EspnPlusLogo);
export default EspnPlusLogo;




// WEBPACK FOOTER //
// ./client/src/components/logos/EspnPlusLogo.jsx